import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { RfpContainer } from '@/components/modules/pages/rfp/Layout/RfpContainer';
import { RfpProfessionalListContent } from '@/components/modules/pages/rfp/professional/Content/RfpProfessionalListContent';
import { Select } from '@/components/ui/Form/Select';
import { ContentContainer } from '@/components/ui/Layout/ContentContainer';
import { BandHead } from '@/components/ui/Typography/Heading/BandHead';
import { myPagePath } from '@/utils/router/links';
/** パンくずリスト */
export const breadcrumbs = [
    {
        link: myPagePath(),
        text: 'マイページ',
    },
    {
        text: '募集中のプロジェクト',
    },
];
/** ソート用のoptions */
export const options = [
    { label: '提案期限が近い順', value: 'deadline' },
    { label: '新着順', value: 'newer' },
];
/**
 * コンサルタント：案件一覧のコンテンツ表示する
 * @param props
 * @constructor
 */
export const ProfessionalRfpListView = (props) => {
    const { loading, onChangeSort, rfps, sort } = props;
    return (_jsx(RfpContainer, Object.assign({ breadcrumbs: breadcrumbs, className: 'mb-32', isFull: true, titleComponent: _jsx(BandHead, Object.assign({ bgColor: 'gradientDarkGreen', className: 'mb-32 pl-0 pr-0' }, { children: _jsx(ContentContainer, Object.assign({ className: 'mx-auto', maxWidthPoint: 'xl' }, { children: "\u52DF\u96C6\u4E2D\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8" })) })) }, { children: _jsxs("div", Object.assign({ className: 'mx-auto w-full max-w-[960px]' }, { children: [_jsx(Select, { className: clsx('flex', 'w-[200px]', 'ml-auto mb-16 mr-16 md:mr-0'), onChange: onChangeSort, options: options, value: sort }), _jsx(RfpProfessionalListContent, { className: 'w-full', loading: loading, rfps: rfps })] })) })));
};
